module.exports = __webpack_public_path__ + "img/2.949c4fd0.jpg";